export default __webpack_public_path__ + "static/media/three-dots.303db2aa.svg";